"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriftCardStack = void 0;
const react_1 = __importDefault(require("react"));
const DriftCard_1 = require("../card/DriftCard");
const Stack_1 = require("../stack/Stack");
const sizeToHeight = {
    small: '61px',
    medium: '80px',
    large: '100px',
};
const DriftCardStack = (props) => {
    const { cardDetails, size = 'small' } = props;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Stack_1.Stack, { direction: "column", spacing: 0 }, cardDetails.map((cardDetail, index) => (react_1.default.createElement(DriftCard_1.DriftCard
        // eslint-disable-next-line react/no-array-index-key
        , Object.assign({ 
            // eslint-disable-next-line react/no-array-index-key
            key: index }, cardDetail, { titleSx: { marginBottom: size === 'small' ? 0 : undefined }, sx: {
                height: sizeToHeight[size],
                borderRadius: 0,
                borderBottom: 'none',
                '&:first-of-type': {
                    borderTopLeftRadius: 4,
                    borderTopRightRadius: 4,
                },
                '&:last-of-type': {
                    borderBottomLeftRadius: 4,
                    borderBottomRightRadius: 4,
                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                },
            } })))))));
};
exports.DriftCardStack = DriftCardStack;
//# sourceMappingURL=DriftCardStack.js.map